import styled from 'styled-components'

export const Title = styled.h5`
  font-size: 20px;
  font-weight: 700;
  margin-top: 10px;
  margin-bottom: 24px;
  color: ${({ theme }) => theme.colors.neutralW90};
`

export const Content = styled.div`
  margin-right: 35px;
`

export const XButtonWrapper = styled.div`
  position: absolute;
  right: 25px;

  svg {
    cursor: pointer;
    width: 24px;
  }
`

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const DescriptionCounter = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 24px;
  color: ${({ theme }) => theme.colors.neutralW70};
  font-size: 12px;
  font-weight: 400;
`
